import { FileText, MessageSquare } from 'lucide-react';
import { useState } from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { ContactQueueTab } from './ContactQueueTab';
import { SmsTemplateAdminTab } from './templates/SmsTemplateAdminTab';

export const ContactQueuePage = () => {
  const [activeTab, setActiveTab] = useState('queue');

  return (
    <div className="h-full flex flex-col bg-zinc-50">
      {/* Header */}
      <div className="flex-shrink-0 border-b bg-white px-6 py-4">
        <div className="flex items-center gap-3">
          <MessageSquare className="h-6 w-6 text-indigo-600" />
          <div>
            <h1 className="text-lg font-semibold text-zinc-900">
              Contact Queue
            </h1>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="flex-1 flex flex-col overflow-hidden"
      >
        <div className="flex-shrink-0 border-b bg-white px-6">
          <TabsList className="h-12 bg-transparent p-0 gap-4">
            <TabsTrigger
              value="queue"
              className="h-12 px-1 pb-3 pt-3 rounded-none border-b-2 border-transparent data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:shadow-none gap-2"
            >
              <MessageSquare className="h-4 w-4" />
              Queue
            </TabsTrigger>
            <TabsTrigger
              value="templates"
              className="h-12 px-1 pb-3 pt-3 rounded-none border-b-2 border-transparent data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:shadow-none gap-2"
            >
              <FileText className="h-4 w-4" />
              SMS Templates
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="queue" className="flex-1 m-0 overflow-hidden">
          <ContactQueueTab />
        </TabsContent>

        <TabsContent value="templates" className="flex-1 m-0 overflow-hidden">
          <SmsTemplateAdminTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
